// @mops/i18n-v1/react — 문장 가운데에 React 요소(<code>·<strong>·링크)를 끼우는 얇은 판.
//
// 왜: t() 는 글자만 돌려준다. 문장 안에 요소가 끼면 문장을 앞뒤 조각으로 쪼개 사전에 넣게 되는데, 그러면
// 사전만 보고는 한 문장이 어떻게 읽히는지 모르고 어순이 코드에 박혀 사전에서 문장을 못 고친다. 그래서
// 문장은 사전에 통째로 두고(`{cmd}` 자리 포함) 자리만 요소로 채운다.
//
// 다섯 서비스(template·hub·mops-code·b3x-in·store)가 같은 것을 각자 만들어서 여기로 올렸다. 모양은 둘이다 —
//   tRich("login.help", { cmd: <code>…</code> })        키로 부른다(template·hub·store)  ← createRich(t)
//   rich(t("k", { err, ...hole("url") }), { url: … })   만든 문장에 끼운다(mops-code·b3x-in)
// 쪼개기는 프레임워크 무관한 richParts(index.js)가 하고, 여기는 React 요소로 감싸기만 한다.
//
// react 는 peerDependency 다(서비스 것을 쓴다) — 이 파일을 import 하는 서비스만 react 가 필요하다.
// 서비스의 vite.config 에 resolve.dedupe: ['react'] 가 있어야 서브모듈 경로에서 react 를 찾는다(README).
import { Fragment, createElement } from "react";
import { richParts } from "./index.js";

/**
 * 문장의 `{이름}` 자리에 요소를 끼운다. 글자 조각은 문자열 그대로, 자리는 `<Fragment key>` 로 감싼다.
 * 값이 없는 자리는 글자 `{이름}` 그대로 남긴다(빈칸으로 숨기지 않는다 — t() 와 같은 약속).
 * @param {string} text
 * @param {Record<string, import("react").ReactNode>} nodes
 */
export function rich(text, nodes = {}) {
  return richParts(text, nodes).map((p, i) =>
    typeof p === "string" ? p : createElement(Fragment, { key: `${p.name}-${i}` }, p.value),
  );
}

/**
 * 사전 t 로 tRich 를 만든다 — `export const tRich = createRich(t)`.
 * tRich(키, { 자리: 요소 }) 는 t 와 같은 키를 받고(없는 키 = 타입 에러), 문장의 자리 이름을 모두 채우라고 한다.
 * 값이 글자·숫자인 자리도 그대로 된다. 없는 키는 t 와 똑같이 키 글자를 보이고 한 번 경고한다.
 * @param {{ dynamic: (key: string) => string | null } & ((key: string) => string)} t
 */
export function createRich(t) {
  return function tRich(key, nodes = {}) {
    // dynamic 은 값 없는 {자리}를 그대로 남기고, 없는 키에 null 을 준다 — 그때만 t() 로 경고를 낸다.
    const text = t.dynamic(key) ?? t(key);
    return rich(text, nodes);
  };
}

export { hole } from "./index.js";
